<template>
	<div class="container pb-10">
		<div class="flex justify-between items-center py-2 mb-4">
			<h1 class="page-title">Facturi Proforme Productie RO</h1>
		</div>

		<div class="light-grey rounded mb-4 p-4">
			<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-10 w-full">
				<div class="w-full lg:w-1/2 flex flex-row items-center gap-2">
					<!-- <v-text-field v-model="filterInput" clearable flat solo hide-details
						prepend-inner-icon="mdi-magnify" label="Cauta proforma dupa client"></v-text-field> -->
					<v-text-field v-model="searchClient" clearable flat solo hide-details
						@keydown.enter="searchProformeProductie" @click:clear="resetInitialProforme"
						prepend-inner-icon="mdi-magnify" label="Cauta proforma dupa client">
					</v-text-field>
					<v-btn color="blue-grey" class="uppercase" large dark @click="searchProformeProductie">Cauta</v-btn>
				</div>
				<div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
					<v-select ref="selectAgent" v-model="filterAgent" class="w-full sm:w-60" :items="agents"
						item-text="username" item-value="id_user" :clearable="true"
						:class="{ 'opacity-60': isProformeProductieSearchList }" @click:clear="$refs.selectAgent.blur()"
						label="Intocmit de" solo hide-details></v-select>
					<div class="w-full sm:w-60">
						<v-menu v-model="monthpickerMenu" class="w-full" :close-on-content-click="false" left
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="monthText" class="date-field"
									:class="{ 'opacity-60': isProformeProductieSearchList }" label="Luna" solo
									prepend-inner-icon="mdi-calendar" hide-details readonly v-bind="attrs"
									v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="selectedMonth" no-title type="month"
								@input="changeMonth"></v-date-picker>
						</v-menu>
					</div>
				</div>
			</div>
		</div>

		<v-sheet
			class="lg:h-28 p-4 rounded mb-1 flex flex-row flex-wrap justify-start lg:justify-end items-start lg:items-center gap-6 lg:gap-20">
			<div>
				<v-label>CA fara TVA</v-label>
				<p class="text-xl text-black font-bold mb-0">{{
					$options.filters.formatRon(totalOferteProforme) }}
				</p>
				<p>{{ $options.filters.formatRon(totalOferteProformeFaraAlte) }}
					<span class="text-sm text-gray-500">fara alte materiale și automatizări</span>
				</p>
			</div>
			<div>
				<v-label>CA fara TVA incasate</v-label>
				<p class="text-xl text-green-500 font-bold mb-0">
					{{ $options.filters.formatRon(totalOferteProformeIncasate) }}
				</p>
			</div>
			<div>
				<v-label>Total proforme</v-label>
				<p class="text-xl text-black font-bold mb-0">{{ $options.filters.formatRon(totalProforme) }}
				</p>
			</div>
			<div>
				<v-label>Total proforme platite</v-label>
				<p class="text-xl text-blue-500 font-bold mb-0">
					{{ $options.filters.formatRon(totalProformePlatite) }}
				</p>
			</div>
			<div>
				<v-label>Total proforme incasate</v-label>
				<p class="text-xl text-green-500 font-bold mb-0">
					{{ $options.filters.formatRon(totalProformeIncasate) }}
				</p>
			</div>
			<div v-if="selectedUser">
				<MonthlyObjective :monthly-amount-objective="monthlyAmountObjective"
					:monthly-objective="monthlyObjective" :size="80" />
			</div>
			<div class="self-start">
				<v-label class="text-sm font-bold">* cifre per luna</v-label>
			</div>
		</v-sheet>

		<v-data-table :headers="headers" :items="filterBy(proforme, filterInput, selectedUser)" item-key="id_proforma"
			:loading="loading" :items-per-page="-1" hide-default-footer>
			<template v-slot:header.suma_proforma="{ header }">
				<div class="flex flex-col justify-center items-start">
					<span>{{ header.text }}</span>
					<span>cu TVA</span>
				</div>
			</template>
			<template v-slot:header.suma_oferta="{ header }">
				<div class="flex flex-col justify-center items-start">
					<span>{{ header.text }}</span>
					<span>cu TVA</span>
				</div>
			</template>
			<template v-slot:item.data="{ item }">
				{{ item.data | formatDate }}
			</template>
			<template v-slot:item.suma_proforma="{ item }">
				{{ item.suma_proforma }} {{ item.moneda }}
			</template>
			<template v-slot:item.suma_oferta="{ item }">
				{{ item.suma_oferta }} {{ item.moneda }}
			</template>
			<template v-slot:item.incasat="{ item }">
				<Incasat :id-proforma="item.id_proforma" :paid-status="item.paid_status"
					@changePaidStatus="changePaidStatus" />
			</template>
			<template v-slot:item.actions="{ item }">
				<Actions :id-proforma="item.id_proforma" :user-role="user.rol" @downloadProforma="downloadProforma"
					@deleteProforma="deleteProforma" />
			</template>
		</v-data-table>

		<!-- <pre>{{ proforme }}</pre> -->
		<!-- <pre>{{firstday}} {{lastday}}</pre> -->
		<!-- <pre>{{ user }}</pre> -->
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { vatRateOnDate, vatRateAddOnDate, vatRateStringOnDate } from '@/utils';
import moment from "moment";
import jsPDF from "jspdf";
import fonts from "../../assets/fonts/fonts.js";
import images from "../../assets/oferta_images.js";
import MonthlyObjective from "@/components/Setari/Objectives/MonthlyObjective"
import Incasat from "./Components/Incasat"
import Actions from "./Components/Actions"
import { pdf_proforma_productie } from "@/documents/proforma/pdf_proforma_productie.js";

export default {
	name: "ProformeProductie",
	components: {
		MonthlyObjective,
		Incasat,
		Actions
	},
	data() {
		return {
			filterInput: "",
			searchClient: null,
			monthpickerMenu: false,
			selectedMonth: new Date().toISOString().substring(0, 7),
			selectedUser: null,
			delID: "",
			headers: [
				{
					text: 'Nr.',
					align: 'start',
					sortable: false,
					value: 'id_proforma'
				},
				{
					text: 'Data',
					align: 'start',
					sortable: false,
					value: 'data',
				},
				{
					text: 'Client',
					align: 'start',
					sortable: false,
					value: 'nume',
				},
				{
					text: 'Oferta',
					align: 'start',
					sortable: false,
					value: 'oferta_id',
				},
				{
					text: 'Tip lucrare',
					align: 'center',
					sortable: false,
					value: 'tip_lucrare',
				},
				{
					text: 'Valoare proforma',
					align: 'start',
					sortable: false,
					value: 'suma_proforma',
				},
				{
					text: 'Valoare oferta',
					align: 'start',
					sortable: false,
					value: 'suma_oferta',
				},
				{
					text: 'Incasat?',
					align: 'center',
					sortable: false,
					value: 'incasat',
				},
				{
					text: 'Intocmit de',
					align: 'start',
					sortable: false,
					value: 'username',
				},
				{
					value: 'actions',
					sortable: false,
					width: '5%'
				}
			],
		};
	},
	computed: {
		monthText() {
			return this.$options.filters.formatMonth(this.selectedMonth)
		},
		firstDay() {
			return new Date(this.selectedMonth).toISOString().split('T')[0]
		},
		lastDay() {
			return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
		},
		loading() {
			return this.$store.getters.loadingProformeProductie;
		},
		proforme() {
			return this.$store.getters.proformeProductie;
		},
		isProformeProductieSearchList() {
			return this.$store.getters.isProformeProductieSearchList
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		// salesObjectives() {
		// 	return {
		// 		daily: 8500,
		// 		month_days: 18
		// 	}
		// },
		// monthlyObjective() {
		// 	const monthlyAmountObjective = Number(this.salesObjectives.daily) * Number(this.salesObjectives.month_days)
		// 	const objective = this.totalOferteProformeIncasate / monthlyAmountObjective * 100
		// 	return Math.round(objective)
		// },
		...mapState('objectives', {
			loadingObjectives: state => state.loadingAllFenceObjectives,
			objectives: state => state.allUserFenceObjectives,
			workingDays: state => state.yearWorkingDays
		}),
		totalOferteProforme() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				let p = Number(proforma.suma_oferta) / this.vatRateAddOnDate(proforma.data)
				if (this.selectedUser && this.selectedUser != proforma.id_user) {
					p = 0
				}
				suma += p
			});
			return suma
		},
		totalOferteProformeFaraAlte() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				let p = Number(proforma.suma_oferta) / this.vatRateAddOnDate(proforma.data)
				p -= this.alteValueForProforma(proforma);
				if (this.selectedUser && this.selectedUser != proforma.id_user) {
					p = 0
				}
				suma += p
			});
			return suma
		},
		totalProforme() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				if (this.selectedUser && this.selectedUser != proforma.id_user) {
					suma += 0
				} else {
					suma += Number(proforma.suma_proforma)
				}
			});
			return suma
		},
		totalProformePlatite() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				if (proforma.paid_status !== "neplatita") {
					if (this.selectedUser && this.selectedUser != proforma.id_user) {
						suma += 0
					} else {
						suma += Number(proforma.suma_proforma)
					}
				}
			});
			return suma
		},
		totalProformeIncasate() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				if (proforma.paid_status === "incasata") {
					if (this.selectedUser && this.selectedUser != proforma.id_user) {
						suma += 0
					} else {
						suma += Number(proforma.suma_proforma)
					}
				}
			});
			return suma
		},
		totalOferteProformeIncasate() {
			let suma = 0;
			this.proforme.forEach((proforma) => {
				if (proforma.paid_status === "incasata") {
					if (this.selectedUser && this.selectedUser != proforma.id_user) {
						suma += 0
					} else {
						suma += (Number(proforma.suma_oferta) / this.vatRateAddOnDate(proforma.data))
					}
				}
			});
			return suma
		},
		selectedMonthObjective() {
			if (this.objectives && this.objectives.length) {
				const objective = this.objectives.find(objective => new Date(objective.date) <= new Date(this.firstDay))
				return objective
			} else {
				return 0
			}
		},
		selectedMonthWorkingDays() {
			if (this.workingDays) {
				const localeStr = new Date(this.firstDay).toLocaleString('en-GB', { month: 'long' })
				const wDays = this.workingDays[localeStr.toLowerCase()]
				return wDays
			} else 0
		},
		monthlyAmountObjective() {
			if (this.workingDays && !!this.selectedMonthObjective) {
				const objectiveAmount = Number(this.selectedMonthObjective.amount) * Number(this.selectedMonthWorkingDays)
				return Math.round(objectiveAmount)
			}
		},
		monthlyObjective() {
			const objective = this.totalOferteProformeIncasate / this.monthlyAmountObjective * 100
			return objective ? Math.floor(objective) : 0
		},
		filterAgent: {
			get() {
				return this.selectedUser
			},
			// setter
			set(newValue) {
				this.selectedUser = newValue
			},
		},
		agents() {
			let array = [];
			let user = {};

			this.proforme.forEach((proforma) => {
				user = {
					id_user: proforma.id_user,
					username: proforma.username,
				};
				if (this.containsObject(user, array)) {
					return;
				} else {
					array.push(user);
				}
			});
			return array.filter(this.onlyUnique);
		}
	},
	watch: {
		isProformeProductieSearchList(newVal) {
			if (newVal) {
				this.selectedUser = null
			} else {
				if (['admin', 'superuser'].includes(this.user.rol)) {
					return
				}
				this.selectedUser = this.user.id_user
			}
		},
		selectedUser(newVal, oldVal) {
			if (newVal != oldVal) {
				this.loadUserAllFenceObjectives([])
				this.fetchObjectives()
			}
		}
	},
	methods: {
		...mapMutations('objectives', ["loadUserAllFenceObjectives"]),
		...mapActions('objectives', ["fetchUserAllFenceObjectives", "fetchWorkingDaysByYear"]),
		vatRateOnDate,
		vatRateAddOnDate,
		vatRateStringOnDate,
		/**
		 * The "alte materiale/produse" of the offer behind a proforma, net, in RON. A fence offer
		 * prices them in EUR, any other offer in RON - the same split grand_total makes.
		 */
		alteValueForProforma(proforma) {
			if (!Array.isArray(proforma.alte_obj)) return 0;
			const value = proforma.alte_obj.reduce((sum, item) => sum + (Number(item.pret_t) || 0), 0);
			return proforma.tip_lucrare == 'gard' ? value * (Number(proforma.curs) || 1) : value;
		},
		replaceSpecialCh(str) {
			return str
				.replace(/ș|Ș/g, "s")
				.replace(/ț|Ț/g, "t")
				.replace(/î|Î/g, "i")
				.replace(/ă|â|Â|Ă/g, "a");
		},
		formatPhoneNo(str) {
			if (str.charAt(0) == "+" || str.charAt(0) == "(") {
				return str;
			} else {
				return "+4" + str;
			}
		},
		dimensiune_text(produs) {
			let str = produs.dimL;
			if (produs.dimH) {
				str += " x " + produs.dimH;
			}
			if (produs.dimG) {
				str += " x " + produs.dimG;
			}
			if (str == null || str == "") {
				return "";
			} else {
				if (!produs.dimH && !produs.dimG) {
					str = "D " + str;
				}
				return str + " mm";
			}
		},
		onlyUnique(value, index, arr) {
			return arr.indexOf(value) === index;
		},
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id_user === obj.id_user) {
					return true;
				}
			}
			return false;
		},
		escapeRegExp(s) {
			return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
		},
		filterBy(list, value, agent) {
			if (!value) {
				value = ""
			}
			const words = value
				.split(/\s+/g)
				.map((s) => s.trim())
				.filter((s) => !!s);

			const hasTrailingSpace = value.endsWith(" ");

			const searchRegex = new RegExp(
				words
					.map((word, i) => {
						if (i + 1 === words.length && !hasTrailingSpace) {
							// The last word - ok with the word being "startswith"-like
							return `(?=.*\\b${this.escapeRegExp(word)})`;
						} else {
							// Not the last word - expect the whole word exactly
							return `(?=.*\\b${this.escapeRegExp(word)}\\b)`;
						}
					})
					.join("") + ".+",
				"i"
			);

			// See if current user has proforme
			// let userProforme = ['admin', 'superuser'].includes(this.user.rol) ? this.agents.find((item) => {
			// 	return item.id_user == agent;
			// }) : undefined;
			let userProforme = this.agents.find((item) => {
				return item.id_user == agent;
			});

			// filter different cases
			return list.filter((proforma) => {
				if (userProforme == undefined || this.isProformeProductieSearchList) {
					return searchRegex.test(proforma.nume);
				} else {
					return (
						searchRegex.test(proforma.nume) &&
						proforma.id_user == agent
					);
				}
			});
		},
		changePaidStatus(id) {
			let proforma = this.proforme.find(
				(proforma) => proforma.id_proforma == id
			);
			let status = "neplatita";

			if (this.user.rol === "admin") {
				if (proforma.paid_status == "neplatita") {
					status = "platita";
				} else if (proforma.paid_status == "platita") {
					status = "incasata";
				}
			} else if (this.user.rol === "superuser" || this.user.rol === 'agent') {
				if (proforma.paid_status == "neplatita") {
					status = "platita";
				} else if (proforma.paid_status == "incasata") {
					return;
				}
			} else {
				return;
			}

			this.$store.dispatch("updateProformaProductiePaidStatus", {
				id: id,
				paid_status: status,
				email_agent: proforma.email_user,
				data_proforma: proforma.data
			});
		},
		changeMonth() {
			this.monthpickerMenu = false
			this.fetchProformeProductie()
		},
		fetchProformeProductie() {
			this.$store.dispatch("fetchProformeProductie", {
				country: "ro",
				date1: this.firstDay,
				date2: this.lastDay,
			});
		},
		resetInitialProforme() {
			this.fetchProformeProductie();
		},
		searchProformeProductie() {
			this.$store.dispatch("fetchProformeProductieBySearchTerm", { country: "ro", searchTerm: this.searchClient })
		},
		async downloadProforma(id) {
			let proforma = this.proforme.find(
				(proforma) => proforma.id_proforma == id
			);
			const doc = await pdf_proforma_productie.createProformaProductiePDF(proforma);
			let pdfName = `Proforma nr. ${proforma.id_proforma} ${proforma.nume}`;
			doc.save(pdfName + ".pdf");
		},
		downloadProforma_old(id) {
			let proforma = this.proforme.find(
				(proforma) => proforma.id_proforma == id
			);
			let pdfName = `Proforma nr. ${proforma.id_proforma} ${proforma.nume}`;
			var imgData = images.data.logo_istruct_cuprolli;
			var doc = new jsPDF();

			//
			// General Settings for Document
			// Font Family
			// add the font to jsPDF
			doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
			doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
			doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
			doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

			// set font
			doc.setFont("Roboto", "normal");
			doc.setTextColor(100);

			// Add Logo
			doc.addImage(imgData, "JPEG", 10, 9, 50, 11);

			//
			// Header - Left side
			doc.setFont("Roboto", "bold");
			doc.setFontSize(10);
			doc.text("Cuprolli Manufacturing srl", 10, 30);
			doc.setFontSize(9);
			doc.setFont("Roboto", "normal");
			doc.text(["CUI/CIF: RO 35671874", "RC: J35/468/2016"], 10, 35, {
				lineHeightFactor: 1.25,
			});
			doc.text(
				["Strada Caprioarei nr.11", "307200 Ghiroda, jud. Timis"],
				10,
				43
			);
			// doc.text("Dumbravita, str. Tarcului nr. 7 ap. 5, jud. Timis", 10, 43);
			doc.setFont("Roboto", "bold");
			doc.text(
				["Banca: Banca Transilvania", "IBAN: RO42 BTRL RONC RT03 3757 8301"],
				10,
				53
			);
			doc.setFont("Roboto", "normal");
			doc.text(
				[
					"Dl/Dna: " + proforma.username,
					"Email: " + proforma.email_user,
					"Tel: " + proforma.tel_user,
				],
				10,
				62,
				{
					lineHeightFactor: 1.35,
				}
			);
			doc.setFont("Roboto", "bold");
			doc.text(`Cota TVA: ${this.vatRateStringOnDate(proforma.data)}`, 10, 78);
			doc.setFont("Roboto", "normal");

			//
			// Header - Right side
			let data = moment(String(proforma.data)).format("DD.MM.YYYY");
			doc.setFontSize(16);
			// doc.setTextColor(243, 153, 46);
			doc.setTextColor(160, 171, 192);
			doc.text("FACTURA  PROFORMA", 130, 15);
			doc.setFontSize(9);
			doc.setTextColor(100);
			doc.text("Nr: " + proforma.id_proforma + " / " + data, 130, 20);

			// Client data
			doc.setFont("Roboto", "bold");
			doc.setFontSize(10);
			doc.text("Client", 130, 30);
			doc.setFontSize(9);
			doc.setFont("Roboto", "normal");
			let nume = this.replaceSpecialCh(proforma.nume);
			let drop = 35;
			let numeSplit = doc.splitTextToSize(nume, 62);
			doc.text(numeSplit, 130, drop, {
				lineHeightFactor: 1.35,
			});
			if (nume.length <= 44) {
				drop = drop + 5;
			} else {
				drop = drop + 9;
			}

			if (proforma.cui) {
				doc.text("CUI/CIF: " + proforma.cui, 130, drop);
				drop = drop + 4;
			}

			if (proforma.adresa) {
				let adresa = this.replaceSpecialCh(proforma.adresa);
				if (proforma.oras) {
					adresa += ", " + this.replaceSpecialCh(proforma.oras);
				}
				let adresaSplit = doc.splitTextToSize(adresa, 62);
				doc.text(adresaSplit, 130, drop);
				if (adresa.length != 0 && adresa.length <= 44) {
					drop = drop + 4;
				} else if (adresa.length != 0 && adresa.length <= 73) {
					drop = drop + 8;
				} else if (adresa.length != 0) {
					drop = drop + 12;
				}
			}

			drop = drop + 1;

			let details = [];
			if (proforma.persoana) {
				details.push("Dl/Dna: " + proforma.persoana);
			}
			if (proforma.email) {
				details.push("Email: " + proforma.email);
			}
			if (proforma.tel != "-") {
				details.push("Tel: " + this.formatPhoneNo(proforma.tel));
			}
			doc.text(details, 130, drop, {
				lineHeightFactor: 1.35,
			});

			doc.setFont("Roboto", "bold");
			doc.setFontSize(10);
			doc.text('Valabilitate factura proforma: 5 zile', 130, drop + 20)
			doc.setFont("Roboto", "normal");
			doc.setFontSize(10);

			// Table header
			doc.setFont("Roboto", "bold");
			doc.text("Nr.", 10, 86);
			doc.text("Denumire produs", 18, 86);
			doc.text("Cantitate", 128, 86);
			doc.text("Pret unitar", 152, 86);
			doc.text("Valoare fara TVA", 174, 86);
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(10, 88, 200, 88);
			let space = 93;
			doc.setFont("Roboto", "normal");

			doc.text("1", 11, space);
			let oferta_data = moment(String(proforma.oferta_data)).format(
				"DD.MM.YYYY"
			);
			doc.text(
				[
					proforma.denumire_produs,
					`Avans ${proforma.procent_proforma}%, conform ofertei nr. ${proforma.oferta_id} din ${oferta_data}`,
				],
				18,
				space,
				{ lineHeightFactor: 1.5 }
			);
			doc.text(proforma.buc_lucrare + " buc", 135, space, {
				align: "center",
			});

			let pret_unitar = proforma.suma_proforma / this.vatRateAddOnDate(proforma.data);
			let valoare = pret_unitar * proforma.buc_lucrare;
			doc.text(pret_unitar.toFixed(2) + " ron", 170, space, { align: "right" });
			doc.text(valoare.toFixed(2) + " ron", 199, space, { align: "right" });

			doc.line(10, space + 8, 200, space + 8);
			space = space + 12;

			// // Footer  - Sum Totals
			// doc.text("Total fara TVA", 147, space + 2);
			// doc.text(pret_unitar.toFixed(2) + " ron", 197, space + 2, {
			// 	align: "right",
			// });
			// doc.text("TVA", 162, space + 7);
			// let tva = pret_unitar * this.$vatRate;
			// doc.text(tva.toFixed(2) + " ron", 197, space + 7, {
			// 	align: "right",
			// });
			// doc.text("TOTAL", 158, space + 12);
			// let total = Number(pret_unitar) + Number(tva);
			// doc.text(total.toFixed(2) + " ron", 197, space + 12, {
			// 	align: "right",
			// });
			// doc.line(10, space + 16, 200, space + 16);

			// space = space + 20;

			// if (proforma.procent_proforma < 100) {
			doc.setFont("Roboto", "bold");
			// doc.text(
			// 	`Total de plata in avans: ${proforma.procent_proforma}%`,
			// 	12,
			// 	space + 2
			// );
			let val_avans = proforma.suma_proforma / this.vatRateAddOnDate(proforma.data);
			doc.text("Total fara TVA", 170, space + 2, {
				align: "right",
			});
			doc.text(val_avans.toFixed(2) + " ron", 199, space + 2, {
				align: "right",
			});
			doc.text("TVA", 170, space + 7, {
				align: "right",
			});
			let tva_avans = val_avans * this.vatRateOnDate(proforma.data);
			doc.text(tva_avans.toFixed(2) + " ron", 199, space + 7, {
				align: "right",
			});
			doc.text("TOTAL", 170, space + 12, {
				align: "right",
			});
			let total_avans = Number(val_avans) + Number(tva_avans);
			doc.text(total_avans.toFixed(2) + " ron", 199, space + 12, {
				align: "right",
			});
			doc.line(10, space + 16, 200, space + 16);
			// }
			doc.save(pdfName + ".pdf");
		},
		selectedProforma(id) {
			this.delID = id;
		},
		deleteProforma(delId) {
			this.$store.dispatch("deleteProformaProductie", {
				id: delId,
				date1: this.firstday,
				date2: this.lastday,
				user_id: this.user.id_user,
			});
		},
		async fetchObjectives() {
			await this.fetchUserAllFenceObjectives({ item: { user_id: this.selectedUser } })
		}
	},
	async created() {
		await this.fetchProformeProductie();
		await this.fetchObjectives()
		await this.fetchWorkingDaysByYear(new Date(this.firstDay).getFullYear())
	},
	mounted() {
		if (!['admin', 'superuser'].includes(this.user.rol)) {
			this.selectedUser = this.user.id_user
		}
		M.Modal.init(document.querySelectorAll(".modal"));

	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.delete-icon:hover {
	color: red !important;
}
</style>

<style scoped>
::v-deep .v-data-table__mobile-table-row {
	display: block !important;
	margin-bottom: 12px;
}
</style>
